import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Select } from "antd";
import { staticOptions } from "./TopicDropdownOptions";

/**
 * TopicDropdown (searchable)
 * - Uses AntD Select for built-in search
 * - Includes a "None" option that sets value to null
 * - Controlled via `value`
 */
const TopicDropdown = ({ title, value, onSelect }) => {
  return (
    <Select
      style={{ width: "100%" }}
      showSearch
      allowClear={true}
      placeholder={title}
      value={value ?? undefined} // AntD Select prefers undefined for "no selection"
      onChange={(v) => onSelect(v ?? null)} // when cleared -> null
      options={staticOptions}
      optionFilterProp="label"
      filterOption={(input, option) => {
        const labelText =
          typeof option?.label === "string"
            ? option.label
            : (option?.label?.props?.children ?? "").toString();

        return labelText.toLowerCase().includes((input || "").toLowerCase());
      }}
      aria-label="Topic"
    />
  );
};

TopicDropdown.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string, // null allowed
  onSelect: PropTypes.func.isRequired,
};

TopicDropdown.defaultProps = {
  value: null,
};

export default connect(() => ({}), {})(TopicDropdown);
